/**
 * 一般来说，2.0中的插件一般用在ssr页面，编辑页面用于代码同步和测试使用，具体代码以ssr端代码为准
 */
import subscribe from "./plugins/subscribe.js"
export default {
  mixins: [subscribe]
}
